/*
 *  
 *  Depends on 
 *  
 *  jquery
 * 
 */

// General name space
var iati = iati || {};

(function(){
	
	var defaultLanguage = "tr";
	var supportedLanguages = ["tr", "en", "de", "ru", "ua"];
	
	var winstatus = 'scrollbars=yes,menubar=no,height=550,width=980,resizable=yes,toolbar=no,location=no,status=no';
	
	iati.util = {
			
			loadValidationMessages : function(language){
				if(language != "en"){ // en is already included language for validation, so no need to include 
					var url = "/js/jq/localization/messages_" + iati.util.getValidLanguage(language) + ".js";
					$.getScript(url);
				}
			},
			
			getValidLanguage : function(language) {
				var validLanguage = defaultLanguage;
				
				for(var i=0; i<supportedLanguages.length; i++) {
					if(supportedLanguages[i] == language) {
						validLanguage = language;
					}
				}
				
				return validLanguage;
			},
			
			prepareSelectedValues : function(){
				$("select[selected]").each(function(){
					var select = $(this);
					select.val(select.attr("selected"));
				});
			},
			
			cleanZeroValues : function(selector){
				$(selector).each(function(){
					var field = $(this);
					var value = field.val();
					if(value == "0" || value == "0.0" || value == "0,0") {
						field.val("");
					}
				});
			},
			
			openWindow : function(url) {
				return window.open(url,'resDetailWindow',winstatus);
			},
			
			relatedSelectBox : function(sourseSelectBoxId, destinationSelectBoxId, url, options) {
				var defaultOptions = {
					parameterName : "id",
					map : {
						value : "id",
						text : "name"
					},
					hasEmptyOption : true,
					emptyOption : {
						value : "0",
						text : "-----------" 
					},
					afterCallback : function(data){},
					beforeCallback : function(param){return true;}
				};
				
				options = $.extend(true, {}, defaultOptions, options);
				
				var fromSelectBox = $("#" + sourseSelectBoxId);
				var destinationSelectBox = $("#" + destinationSelectBoxId);
				
				fromSelectBox.change(function(event) {
					var parameters = {};
					parameters[options.parameterName] = fromSelectBox.val();
					if(options.beforeCallback(parameters)){
						$.getJSON(url, parameters, function(data) {
							$('option',destinationSelectBox).remove();
							
							var optionsText = "";
							if(options.hasEmptyOption){
								optionsText += getOptionText(options.emptyOption.value, options.emptyOption.text);
							}
							$.each(data, function(i, item) {
								optionsText += getOptionText(item[options.map.value] , item[options.map.text]);
							});
							destinationSelectBox.append(optionsText);
							options.afterCallback(data);
						});						
					}
				});
				
				function getOptionText(value, label){
					return '<option value="' + value + '">' + label + '</option>';
				}
			},
			
			/*
			 * depends on 
			 * -- jquery input mask
			 * 
			 */
			getPhoneNumberFieldManager : function(countryCodeId, phoneNumberId){
				var countryPhoneCode = $("#" + countryCodeId);
				var phoneNumberField = $("#" + phoneNumberId);
				var turkeyPhoneMask = "(999) 999 9999";
				var disable = false;
				
				function prepareGsmMask(event){
					var countryCode = countryPhoneCode.val();
					if(!disable && countryCode == "90"/*Turkey*/ && countryCode != "98" /*Iran*/) {
						phoneNumberField.mask(turkeyPhoneMask)
					}else{
						phoneNumberField.unmask().val(phoneNumberField.val().replace(/[\(\)\s]/g, ""));
					}
				}
				
				countryPhoneCode.change(prepareGsmMask);
				prepareGsmMask();
				return {
					disableMask : function(){
						disable = true;
						prepareGsmMask();
					},
					
					enableMask : function(){
						disable = false;
					}
				}
			},
			
			trim : function(text){
				var trimedText = text;
				if(text){
					trimedText = text.replace(/^\s+|\s+$/g, '');
				}
				return trimedText;
			},
			
			parseInt : function(text){
				if(text == null) return 0;
				
				return parseInt(text);
			}
	}
})();